export const categories = [
  {
    slug: "fails",
    name: "翻车现场",
    slogan: "灯光音响全配合，偏偏结果出了岔子",
    description:
      "从念错名字到礼服出状况，翻车现场记录那些与预期完全相反的瞬间。这里不嘲笑当事人，只复盘流程里到底哪一步松了扣。",
    count: 3,
    icon: "ri-alarm-warning-line",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20lit%20empty%20pageant%20stage%20with%20a%20single%20stray%20spotlight%20and%20red%20velvet%20curtains%2C%20moody%20editorial%20photography%2C%20warm%20amber%20tones%2C%20cinematic%20composition&width=1200&height=800&seq=cat-fails-hero-01&orientation=landscape",
  },
  {
    slug: "awkward",
    name: "尴尬瞬间",
    slogan: "空气突然安静的三秒钟",
    description:
      "问答答非所问、麦克风没关、掌声落空，尴尬瞬间专收那些让人替台上捏把汗的时刻，附上主持人是如何把场子圆回来的。",
    count: 2,
    icon: "ri-emotion-unhappy-line",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20backstage%20corridor%20of%20a%20theater%20with%20warm%20dim%20lights%20and%20wooden%20floor%2C%20empty%20chair%2C%20editorial%20photography%2C%20warm%20brown%20tone%2C%20soft%20shadows&width=1200&height=800&seq=cat-awkward-hero-01&orientation=landscape",
  },
  {
    slug: "funny",
    name: "搞笑名场面",
    slogan: "那一刻全场都在憋笑",
    description:
      "崴脚救场、BGM 放错、才艺加戏，搞笑名场面合集收录那些意外却精彩的临场反应，顺便看看专业选手的临场素养到底有多强。",
    count: 3,
    icon: "ri-emotion-laugh-line",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20pageant%20runway%20with%20warm%20amber%20lights%20and%20confetti%20in%20the%20air%2C%20elegant%20evening%20gowns%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20joyful%20atmosphere&width=1200&height=800&seq=cat-funny-hero-01&orientation=landscape",
  },
  {
    slug: "judge",
    name: "评委表情",
    slogan: "分数没打完，表情先出卖了",
    description:
      "镜头扫过评委席的那几秒，信息量往往比整场比赛还大。评委表情栏目带你逐帧解读那些忍不住、端不住、又不好说破的瞬间。",
    count: 2,
    icon: "ri-user-star-line",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20panel%20judges%20table%20with%20notebooks%20and%20scorecards%20under%20warm%20spotlights%2C%20empty%20stage%20in%20background%2C%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones&width=1200&height=800&seq=cat-judge-hero-01&orientation=landscape",
  },
  {
    slug: "elimination",
    name: "淘汰时刻",
    slogan: "宣布名单之后的那三十秒",
    description:
      "淘汰时刻不只记录谁离开了舞台，更记录台下、侧幕和后台反应。这里的每一段都尽量还原当时的完整语境，不做断章取义。",
    count: 2,
    icon: "ri-door-open-line",
    cover:
      "https://readdy.ai/api/search-image?query=Theater%20wings%20beside%20a%20warmly%20lit%20stage%20with%20draped%20curtains%20and%20a%20single%20spotlight%2C%20quiet%20backstage%20mood%2C%20editorial%20photography%2C%20warm%20amber%20tones&width=1200&height=800&seq=cat-elim-hero-01&orientation=landscape",
  },
];